import { create } from 'zustand';

/**
 * overridesVersion — se incrementa cada vez que Modo Edición guarda un
 * cambio (o al arrancar la app). `santaColomaIntersections`/
 * `santaColomaStaticSignals` se mutan in-place (ver overridesRuntime.ts),
 * así que no disparan un re-render por sí solos — el único punto donde se
 * itera para pintar el mapa (`SantaColomaMapView.tsx`) se suscribe a esta
 * versión para saber cuándo volver a leerlos.
 */
interface OverridesVersionState {
  version: number;
  bump: () => void;
}

export const useOverridesVersion = create<OverridesVersionState>((set) => ({
  version: 0,
  bump: () => set(s => ({ version: s.version + 1 })),
}));
